const MAX_MAILTO = 2000;

export function fillTemplate(tpl, vars = {}) {
  if (!tpl) return '';
  return String(tpl).replace(/\{(\w+)\}/g, (_, k) => (vars[k] != null ? String(vars[k]) : ''));
}

export function buildMailtoUrl({ to, subject, body, bcc }) {
  const params = [];
  if (subject) params.push(`subject=${encodeURIComponent(subject)}`);
  if (body) params.push(`body=${encodeURIComponent(body)}`);
  if (bcc) params.push(`bcc=${encodeURIComponent(bcc)}`);
  let href = `mailto:${to || ''}${params.length ? `?${params.join('&')}` : ''}`;
  let truncated = false;
  if (href.length > MAX_MAILTO) {
    const shortBody = `${body || ''}\n\n(continued separately — see Fair guidance)`.slice(0, 500);
    const shortParams = [];
    if (subject) shortParams.push(`subject=${encodeURIComponent(subject)}`);
    shortParams.push(`body=${encodeURIComponent(shortBody)}`);
    if (bcc) shortParams.push(`bcc=${encodeURIComponent(bcc)}`);
    href = `mailto:${to}?${shortParams.join('&')}`;
    truncated = true;
  }
  return { href, truncated };
}
